import Swiper from 'swiper/bundle'
import Lightbox from 'utils/_lightbox'

export default class SliderTable {
  constructor () {
    const SWIPER_WRAPPERS = document.querySelectorAll('.mtt-slider-table')

    if (SWIPER_WRAPPERS.length) {
      for (let i = 0; i < SWIPER_WRAPPERS.length; i++) {
        const SWIPER_WRAPPER = SWIPER_WRAPPERS[i]
        new TableSwiper(SWIPER_WRAPPER)
      }
    }
  }
}

class TableSwiper {
  constructor (SWIPER_WRAPPER) {
    this.SWIPER_WRAPPER = SWIPER_WRAPPER
    this.MAIN_SWIPER = this.SWIPER_WRAPPER.querySelector('.mtt-slider-table__slider.swiper-container')
    this.THUMBS_SWIPER = this.SWIPER_WRAPPER.querySelector('.mtt-slider-table__slider-thumbs.swiper-container')
    this.PREV_BTN = this.SWIPER_WRAPPER.querySelector('.mtt-slider-table__slider-prev')
    this.NEXT_BTN = this.SWIPER_WRAPPER.querySelector('.mtt-slider-table__slider-next')

    if (this.MAIN_SWIPER) {
      new Lightbox(this.MAIN_SWIPER.querySelectorAll('.mtt-slider-table__image img'))
      this.SWIPER_COUNT = this.MAIN_SWIPER.querySelectorAll('.swiper-slide').length
      this.addSwiper()
    }
  }

  addSwiper() {
    let THUMBS_SWIPER = null

    if  (this.SWIPER_COUNT > 1) {
      THUMBS_SWIPER = new Swiper(this.THUMBS_SWIPER, {
        watchSlidesProgress: true,
        spaceBetween: 12,
        slidesPerView: 3,
        threshold: 10,
        centerInsufficientSlides: true
      })
    }


    const MAIN_SWIPER = new Swiper(this.MAIN_SWIPER, {
      watchOverflow: true,
      spaceBetween: 40,
      threshold: 10,
      navigation: {
        prevEl: this.PREV_BTN,
        nextEl: this.NEXT_BTN
      },
      thumbs: {
        swiper: THUMBS_SWIPER,
      },
    })
  }
}